function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("path", {
  d: "M3.57831 5.21353L0.281143 1.82966C-0.102848 1.51875 -0.0919683 0.984075 0.304426 0.685366C0.640883 0.431823 1.14067 0.439183 1.46722 0.702488L4.5 3.86221L7.53278 0.702487C7.85933 0.439183 8.35912 0.431823 8.69557 0.685366C9.09197 0.984075 9.10285 1.51875 8.71886 1.82966L5.42169 5.21353C5.42169 5.21353 5.04475 5.5 4.5 5.5C3.95525 5.5 3.57831 5.21353 3.57831 5.21353Z",
  fill: "#011FBB"
});

const SvgPoStatusDropdown = (_ref) => {
  let {
    svgRef,
    title
  } = _ref,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    width: 9,
    height: 6,
    viewBox: "0 0 9 6",
    fill: "none",
    ref: svgRef
  }, props), title ? React.createElement("title", null, title) : null, _ref2);
};

const ForwardRef = React.forwardRef((props, ref) => React.createElement(SvgPoStatusDropdown, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/po_status_dropdown.00432701.svg";
export { ForwardRef as ReactComponent };